import {
  FormCard,
  FormItem,
  FormRadio,
  FormRadioGroup,
  Input,
  TextArea,
} from '@lmc/ui-kit'
import { NAMESPACE } from 'locale'
import { serviceUserProfileConstants as supConstants } from 'locale/serviceUserProfile'
import { useTranslation } from 'react-i18next'
import { AddressForm } from 'screens/Residents/screens/ResidentProfileScreen/screens/ResidentContactDetails/FormCards/Address/AddressForm'
import { Text } from '@lmc/ui-kit/src/general'
import {
  ImportantContactAddress,
  ImportantContactBodyDtos,
} from '@lmc/ts-common/lib/dtos/Resident'
import { Form } from 'antd'

export type ContactDetailsFormType = {
  address: Pick<
    ImportantContactAddress,
    'street1' | 'street2' | 'state' | 'postcode' | 'name' | 'suburb'
  >
} & Pick<
  ImportantContactBodyDtos,
  'telephone' | 'telephoneSecondary' | 'contactStatus' | 'contactableTimes'
>

export enum ContactStatus {
  'priority' = 'priority',
  'secondary' = 'secondary',
  'doNotContact' = 'doNotContact',
}

const ContactDetailsFormCard = () => {
  const { t } = useTranslation(NAMESPACE.SERVICE_USER_PROFILE)

  return (
    <FormCard title={t(supConstants.CONTACT_DETAILS)}>
      <Form.Item shouldUpdate={() => false}>
        {({ getFieldValue, setFieldValue }) => {
          const isAddressFilled = !!getFieldValue(['address'])
          return (
            <AddressForm
              fieldName={['address']}
              onAutofill={(values) => setFieldValue('address', values)}
              title={t(supConstants.ADDRESS)}
              initialIsAddingAddressManually={isAddressFilled}
            >
              <FormItem
                label={<Text>{t(supConstants.BUILDING_NAME)}</Text>}
                name={['address', 'name']}
              >
                <Input />
              </FormItem>
              <FormItem
                label={<Text>{t(supConstants.ADDRESS_LINE_1)}</Text>}
                name={['address', 'street1']}
              >
                <Input />
              </FormItem>
              <FormItem
                label={<Text>{t(supConstants.ADDRESS_LINE_2)}</Text>}
                name={['address', 'street2']}
              >
                <Input />
              </FormItem>
              <FormItem
                label={<Text>{t(supConstants.TOWN_CITY)}</Text>}
                name={['address', 'suburb']}
              >
                <Input />
              </FormItem>
              <FormItem
                label={<Text>{t(supConstants.COUNTRY)}</Text>}
                name={['address', 'state']}
              >
                <Input />
              </FormItem>
            </AddressForm>
          )
        }}
      </Form.Item>
      <FormItem label={t(supConstants.TELEPHONE1)} name="telephone">
        <Input />
      </FormItem>
      <FormItem label={t(supConstants.TELEPHONE2)} name="telephoneSecondary">
        <Input />
      </FormItem>
      <FormItem label={t(supConstants.EMAIL)} name="email">
        <Input type="email" name="email" />
      </FormItem>
      <FormItem label={t(supConstants.CONTACT_STATUS)} name="contactStatus">
        <FormRadioGroup>
          {Object.keys(ContactStatus).map((status) => (
            <FormRadio
              key={status}
              value={status}
              text={t(supConstants[status as ContactStatus])}
            />
          ))}
        </FormRadioGroup>
      </FormItem>
      <FormItem
        label={t(supConstants.CONTACTABLE_TIMES)}
        name="contactableTimes"
      >
        <TextArea />
      </FormItem>
    </FormCard>
  )
}

export default ContactDetailsFormCard
